import { Injectable } from '@angular/core';
import { VerificationOverride } from 'models';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
	providedIn: 'root',
})
export class VerificationService {
	constructor(private http: HttpClient) {}

	public overrideVerification(verificationOverride: VerificationOverride): Observable<null> {
		return this.http.post<null>('api/verifications/override', verificationOverride);
	}

	public resetGovernmentId(userId: string): Observable<void> {
		return this.http.delete<void>(`api/verifications/resetgovernmentid/${userId}`);
	}

	public viewSignature(verificationId: string): Observable<Blob> {
		return this.http.get<Blob>(`api/verifications/${verificationId}/view-signature`, { responseType: 'blob' as 'json' });
	}

	public viewContract(verificationId: string): Observable<Blob> {
		return this.http.get<Blob>(`api/verifications/${verificationId}/view-contract`, { responseType: 'blob' as 'json' });
	}
}
